import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { getFullUrl } from 'hubspot-url-utils';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
const ValidationMessageFromField = ({
  validationErrors,
  email,
  allowOtherEmails
}) => {
  const INBOX_SETTINGS_URL = `${getFullUrl('app')}/live-messages-settings/${PortalIdParser.get()}/inboxes`;
  const INVOICE_SETTINGS_URL = `${getFullUrl('app')}/settings/${PortalIdParser.get()}/sales/invoices`;
  const EMAIL_SETTINGS_URL = `${getFullUrl('app')}/settings/${PortalIdParser.get()}/user-preferences/email`;
  switch (true) {
    case validationErrors.from.defaultEmailDisabled:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: allowOtherEmails ? 'invoices.components.sendInvoiceModal.fields.from.validationMessage.defaultEmailDisabled.allowOtherEmails_jsx' : 'invoices.components.sendInvoiceModal.fields.from.validationMessage.defaultEmailDisabled.allowOtherEmailsOff_jsx',
        elements: {
          UILink
        },
        options: {
          inboxSettings: {
            href: INBOX_SETTINGS_URL
          },
          invoiceSettings: {
            href: INVOICE_SETTINGS_URL
          }
        }
      });
    case validationErrors.from.empty:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "invoices.components.sendInvoiceModal.fields.from.validationMessage.empty",
        options: {
          email
        }
      });
    case validationErrors.from.userEmailDisabled:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.components.sendInvoiceModal.fields.from.validationMessage.userEmailDisabled_jsx",
        elements: {
          UILink
        },
        options: {
          href: EMAIL_SETTINGS_URL
        }
      });
    case validationErrors.from.teamEmailDisabled:
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "invoices.components.sendInvoiceModal.fields.from.validationMessage.teamEmailDisabled_jsx",
        elements: {
          UILink
        },
        options: {
          href: INBOX_SETTINGS_URL
        }
      });
    default:
      return null;
  }
};
export default ValidationMessageFromField;